//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { IPromotedPostsBudgetState } from '../models/AppState';
import {
    PROMOTED_POSTS_BUDGET_ACTIONS,
} from '../promoted-posts-constants/promoted-posts-budget-constants';

// Defaults from Instagram's in-app experience
const initialState: IPromotedPostsBudgetState = {
  budget: null, // We cannot assume a default budget due to foreign currencies
  duration: 6,
  isHighBudget: false,
  budgetIsValid: true,
};

export default function PromotedPostsBudgetReducer(state = initialState, action) {
  switch (action.type) {
    case PROMOTED_POSTS_BUDGET_ACTIONS.CLEAR_PROMOTED_POSTS_BUDGET_STATE:
      return initialState;
    case PROMOTED_POSTS_BUDGET_ACTIONS.UPDATE_BUDGET:
      return {
        ...state,
        budget: action.payload.budget,
        isHighBudget: action.payload.isHighBudget,
        budgetIsValid: action.payload.budgetIsValid,
      };
    case PROMOTED_POSTS_BUDGET_ACTIONS.UPDATE_DURATION:
      return {
        ...state,
        duration: action.payload.duration,
        isHighBudget: action.payload.isHighBudget,
      };
    default:
      return state;
  }
}
